import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'mediaContainer',
    'assetIdField',
    'assetManagementButtons',
    'selectMediaButton',
    'destroyField',
    'editButton'
  ]
  static values = {
    existingImg: { type: String, default: '' },
    mediaIndexUrl: String
  }

  connect() {
    this.existingImgValue = this.mediaContainerTarget.querySelector('img') || ''
    this.setControlsVisibility()
  }

  showGallery(event) {
    event.preventDefault()
    const mediaType = event.params.mediaType
    this.dispatch(
      'showGallery', { detail: { mediaType: mediaType }}
    )
  }

  removeSelectedMedia(event) {
    event.preventDefault()

    this.removeAsset()
    this.setControlsVisibility()
  }

  handleAssetSelected(event) {
    const { assetUrl, assetId, assetEditUrl, assetName, assetIsImage, target } = event.detail

    if (this.element === target) {
      if (this.existingImgValue.length > 0) {
        this.removeAsset()
      }

      const imgElement = document.createElement('img')
      imgElement.className = 'img img-thumbnail'
      imgElement.src = assetUrl

      const linkElement = document.createElement('a')
      linkElement.href = '#'
      linkElement.dataset.action = 'click->media-edit#loadEditModal'
      linkElement.dataset.mediaEditAssetUrlParam = assetEditUrl
      linkElement.dataset.mediaLibraryTarget = 'editButton'
      linkElement.appendChild(imgElement)

      const fileNameElement = document.createElement('p')
      fileNameElement.className = 'file-name'
      fileNameElement.innerText = assetName

      this.mediaContainerTarget.prepend(fileNameElement)
      this.mediaContainerTarget.prepend(linkElement)

      this.existingImgValue = imgElement
      this.assetIdFieldTarget.value = assetId
      this.destroyFieldTarget.value = '0'

      if (this.hasEditButtonTarget) {
        if (assetIsImage === true) {
          this.editButtonTargets.forEach(button => {
            button.dataset.mediaEditAssetUrlParam = assetEditUrl
            button.classList.remove('hidden')
          })
        } else {
          this.editButtonTargets.forEach(button => {
            button.classList.add('hidden')
          })
        }
      }

      this.setControlsVisibility()
    }
  }

  setControlsVisibility() {
    if (this.existingImgValue.length > 0) {
      this.selectMediaButtonTarget.classList.add('hidden')
      this.assetManagementButtonsTarget.classList.remove('hidden')
    } else {
      this.selectMediaButtonTarget.classList.remove('hidden')
      this.assetManagementButtonsTarget.classList.add('hidden')
    }
  }

  removeAsset() {
    this.mediaContainerTarget.querySelector('a').remove()
    this.mediaContainerTarget.querySelector('.file-name').remove()
    this.existingImgValue = ''
    this.assetIdFieldTarget.value = ''
    this.destroyFieldTarget.value = '1'
  }
}
